import CONSTANT from "../../constants/Constant";

/**
 * Scans all groups and questions to determine if the assessment should be blocked.
 * Returns { isBlocked: boolean, exitWorkflowMessage: string }
 */
export const checkAssessmentBlockedState = (groups) => {
    let isBlocked = false;
    let exitWorkflowMessage = "";

    (groups || []).forEach(group => {
        if (isBlocked) return;
        
        // Handle both DTO 'subGroups' and RAW 'HeaderSectionView'
        const rawSubGroups = group.subGroups || group.HeaderSectionView || [];
        
        rawSubGroups.forEach(subGroup => {
            if (isBlocked) return;
            
            // Handle both DTO 'questions' and RAW 'ExamResponse'
            const rawQuestions = subGroup.questions || subGroup.ExamResponse || [];
            
            rawQuestions.forEach(question => {
                if (isBlocked) return;
                
                const answerId = question.answerId || question.AnswerId;
                const answerValue = question.answerValue || question.AnswerValue;
                const responses = question.responses || question.Responses || [];

                if ((answerId && answerId !== 0) || (answerValue && answerValue !== "")) {
                    // Try to find selected response in the mapped DTO structure or raw structure
                    let selectedResponse = (responses || []).find(r => 
                        Number(r.id) == Number(answerId) || Number(r.AnswerId) == Number(answerId)
                    );

                    // Fallback matching logic
                    if (!selectedResponse || (!selectedResponse.isExitWorkflow && !selectedResponse.IsExitWorkflow)) {
                        const isNoAnswer = (answerValue || "").toString().toLowerCase().trim() === "no";
                        if (isNoAnswer) {
                            // Check if ANY response for this question triggers an exit.
                            const exitResponse = (responses || []).find(r => r.isExitWorkflow || r.IsExitWorkflow);
                            if (exitResponse) {
                                selectedResponse = exitResponse;
                            } else {
                                // Emergency Fallback for essential job requirements
                                // Check both DTO 'text' and RAW 'QuestionTitle'
                                const qTxt = (question.text || question.QuestionTitle || "").toLowerCase();
                                const isClimbSteps = qTxt.includes("climb steps") && (qTxt.includes("ladders") || qTxt.includes("12–20") || qTxt.includes("12-20"));
                                const isSit4Hours = qTxt.includes("sit for") && qTxt.includes("4 hours") && qTxt.includes("pain");
                                
                                if (isClimbSteps || isSit4Hours) {
                                    isBlocked = true;
                                    exitWorkflowMessage = "Thank you for completing the Pre-Assessment Functional Questionnaire. Based on your answers indicating that you are not able to climb steps/ladders (12–20 inches) or sit for up to 4 hours, we are unable to proceed with your application, as these are essential job requirements.";
                                    return;
                                }
                            }
                        }
                    }

                    if (selectedResponse?.isExitWorkflow || selectedResponse?.IsExitWorkflow) {
                        isBlocked = true;
                        exitWorkflowMessage = selectedResponse.exitWorkflowMessage || selectedResponse.ExitWorkflowMessage;
                    }
                }
            });
        });
    });

    return { isBlocked, exitWorkflowMessage };
};
